export default __webpack_public_path__ + "static/media/flechaRoja.4a85683f.svg";